import React from "react";
import { ResponsiveHeader } from "pages/_components/header";
import { isEmpty } from "lodash";
import { useSelector } from "react-redux";
import MainContainer from "pages/_components/MainContainer";
import GridTable from "pages/_components/GridTable/GridTable";
import I18n from "pages/_components/I18n";
import Button from "pages/_components/Button";
import { Col, Row } from "react-bootstrap";
import FormattedAmount from "pages/_components/FormattedAmount";
import Loader from "pages/_components/Loader";
import { findBeneficiary } from "util/echecks";
import CustomData from "pages/_components/CustomData/CustomData";
import { useExecuteAction } from "../hooks/useExecuteAction";
import SummaryActions from "../components/SummaryActions";

const titles = {
    "ANULATE-ECHEQ": "echecks.anulate",
    "ANULATE-ENDORSE": "echeq.anulate-endorse.echeq",
    "ANULATE-CESION": "echeq.anulate.cesion.echeq",
    "REQUEST-RETURN": "echecks.requestRetun",
    "ANULATE-RETURN": "echecks.anulateRetun",
    "ACCEPT-RETURN": "echecks.acceptRetun",
    "REPUDIATE-RETURN": "echecks.repudiateRetun",
};

const AnulateEcheckPage = () => {
    const { environmentCuit, echeqsToDoActions: echeqAction } = useSelector((state) => state.echecks);
    const { isSubmitting, executeEcheqAction } = useExecuteAction(echeqAction);

    if (isEmpty(echeqAction)) {
        return <Loader />;
    }

    return (
        <>
            <ResponsiveHeader id={titles[echeqAction?.action]} />
            <MainContainer>
                <h2>
                    <I18n id="echecks.summary.confirm" />
                </h2>
                <div className="above-the-fold">
                    {echeqAction?.echeqList?.length > 1 && <SummaryActions list={echeqAction?.echeqList} />}
                    {echeqAction?.echeqList?.map((echeq) => {
                        const beneficiary = findBeneficiary(echeq, environmentCuit);
                        return (
                            <>
                                <GridTable className="form-summary">
                                    <GridTable.Container>
                                        <GridTable.Data>
                                            <CustomData
                                                titleText="echecks.number.label"
                                                titleTextType="I18N"
                                                valueText={echeq.cheque_numero}
                                            />
                                        </GridTable.Data>
                                        <GridTable.Data>
                                            <CustomData
                                                titleText="echecks.document"
                                                titleTextType="I18N"
                                                valueText={beneficiary.beneficiarioDocumento}
                                            />
                                        </GridTable.Data>
                                        <GridTable.Data>
                                            <CustomData
                                                titleText="echecks.amount"
                                                titleTextType="I18N"
                                                valueText={
                                                    <FormattedAmount
                                                        className="data-label"
                                                        currency={echeq.emisor_moneda}
                                                        quantity={echeq.monto}
                                                    />
                                                }
                                            />
                                        </GridTable.Data>
                                        <GridTable.Data>
                                            <CustomData
                                                titleText="echecks.beneficiary"
                                                titleTextType="I18N"
                                                valueText={beneficiary.beneficiarioRazonSocial}
                                            />
                                        </GridTable.Data>
                                        {echeqAction.action !== "REQUEST-RETURN" && (
                                            <GridTable.Data>
                                                <CustomData
                                                    titleText="echecks.id.label"
                                                    titleTextType="I18N"
                                                    valueText={echeq.cheque_id}
                                                />
                                            </GridTable.Data>
                                        )}
                                        <GridTable.Data>
                                            <CustomData
                                                titleText="echecks.currency"
                                                titleTextType="I18N"
                                                valueText={echeq.moneda}
                                            />
                                        </GridTable.Data>
                                        {echeqAction.action !== "REQUEST-RETURN" && (
                                            <GridTable.Data>
                                                <CustomData
                                                    titleText="echecks.emit.type.label"
                                                    titleTextType="I18N"
                                                    valueText={`echecks.emit.${echeq?.cheque_tipo}`}
                                                    valueTextType="I18N"
                                                />
                                            </GridTable.Data>
                                        )}
                                        <GridTable.Data>
                                            <CustomData
                                                titleText="echecks.createdRange.label"
                                                titleTextType="I18N"
                                                valueText={echeq.fecha_emision}
                                                valueTextType="DATE"
                                            />
                                        </GridTable.Data>
                                        <GridTable.Data>
                                            <CustomData
                                                titleText="echecks.payedRange.label"
                                                titleTextType="I18N"
                                                valueText={echeq.fecha_pago}
                                                valueTextType="DATE"
                                            />
                                        </GridTable.Data>
                                        {echeqAction.action !== "REQUEST-RETURN" && (
                                            <GridTable.Data>
                                                <CustomData
                                                    titleText="echecks.echeckNature"
                                                    titleTextType="I18N"
                                                    valueText={echeq.cheque_caracter}
                                                />
                                            </GridTable.Data>
                                        )}
                                        {echeqAction.action !== "REQUEST-RETURN" && (
                                            <GridTable.Data>
                                                <CustomData
                                                    titleText="echecks.echeckMode"
                                                    titleTextType="I18N"
                                                    valueText={
                                                        echeq.cheque_modo === 1
                                                            ? "echecks.emit.cross"
                                                            : "echecks.emit.uncross"
                                                    }
                                                    valueTextType="I18N"
                                                />
                                            </GridTable.Data>
                                        )}
                                        {echeqAction.action !== "REQUEST-RETURN" && (
                                            <GridTable.Data>
                                                <CustomData
                                                    titleText="echecks.echeckConcept"
                                                    titleTextType="I18N"
                                                    valueText={`transfer.reasons.${echeq.cheque_concepto}`}
                                                    valueTextType="I18N"
                                                />
                                            </GridTable.Data>
                                        )}
                                        {echeqAction.action !== "REQUEST-RETURN" && (
                                            <GridTable.Data>
                                                <CustomData
                                                    titleText="echecks.emit.motive.label"
                                                    titleTextType="I18N"
                                                    valueText={echeq.cheque_motivo_pago}
                                                />
                                            </GridTable.Data>
                                        )}
                                        {echeqAction.action === "ANULATE-ENDORSE" && (
                                            <>
                                                <GridTable.Data>
                                                    <CustomData
                                                        titleText="echecks.endorse.date"
                                                        titleTextType="I18N"
                                                        valueText={echeq.endosos[0]?.fecha_hora}
                                                        valueTextType="DATE"
                                                    />
                                                </GridTable.Data>
                                                <GridTable.Data>
                                                    <CustomData
                                                        titleText="echecks.endorse.type.label"
                                                        titleTextType="I18N"
                                                        valueText={`echecks.endorse.types.${echeq.endosos[0]?.tipo_endoso}`}
                                                        valueTextType="I18N"
                                                    />
                                                </GridTable.Data>
                                            </>
                                        )}
                                        {echeqAction.action === "ANULATE-CESION" && (
                                            <>
                                                <GridTable.Data>
                                                    <CustomData
                                                        titleText="echecks.cession.dateTime"
                                                        titleTextType="I18N"
                                                        valueText={echeq.cesiones[0]?.fecha_emision_cesion}
                                                        valueTextType="DATE"
                                                    />
                                                </GridTable.Data>
                                                <GridTable.Data>
                                                    <CustomData
                                                        titleText="echecks.cession.beneficiaryAddress"
                                                        titleTextType="I18N"
                                                        valueText={echeq.cesiones[0]?.cesionario_domicilio}
                                                    />
                                                </GridTable.Data>
                                            </>
                                        )}
                                        {(echeqAction.action === "ANULATE-ENDORSE" ||
                                            echeqAction.action === "ANULATE-ECHEQ") && (
                                            <GridTable.Data>
                                                <CustomData
                                                    titleText="echeck.anulate.label"
                                                    titleTextType="I18N"
                                                    valueText={echeqAction.specialAttribute}
                                                />
                                            </GridTable.Data>
                                        )}
                                        {echeqAction.action === "REQUEST-RETURN" && (
                                            <GridTable.Data>
                                                <CustomData
                                                    titleText="echeck.RequestRetun.label"
                                                    titleTextType="I18N"
                                                    valueText={echeqAction.specialAttribute}
                                                />
                                            </GridTable.Data>
                                        )}
                                    </GridTable.Container>
                                </GridTable>
                            </>
                        );
                    })}

                    <Row className="form-actions no-print">
                        <Col xs={12} md={4} mdOffset={4}>
                            <Button
                                type="submit"
                                bsStyle="primary"
                                label="global.send"
                                onClick={executeEcheqAction}
                                loading={isSubmitting}
                            />
                        </Col>
                    </Row>
                </div>
            </MainContainer>
        </>
    );
};

export default AnulateEcheckPage;
